import { createTheme } from "@mui/material/styles"


const muiTheme = createTheme({
    typography: {
        fontFamily: ["DejaVu Sans", "sans-serif"].join(','),
    },

    palette: {
        mode: 'dark'
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === "contained" &&
                        ownerState.color === "primary" && {
                        backgroundColor: theme_.themeColor,
                    }),

                    ...(ownerState.variant === "outlined" && {
                        borderColor: theme_.themeColor,
                        color: theme_.themeColor,
                    }),

                }),
            },
        },
        MuiTypography: {
            defaultProps: {
                color: 'white',
            },
        },
        MuiTab: {
            styleOverrides: {
                textColorPrimary: {
                    color: "white",
                    "&.Mui-selected": {
                        color: "orange"
                    }
                },
                textColorSecondary: {
                    color: "white"
                }
            }
        },
    },
})

//console.debug(muiTheme)

export default muiTheme
